import Urls from '../urls.js';
import { fetch_status, fetch_json, fetch_error, fetcher } from '../../../../scripts/utils/fetch.js';
import BaseView from '../../../../scripts/utils/base-view.js';

export default class AddToCartModalView extends BaseView {
	constructor({ adv_source, cart_product, el }) {
		super(el);
		this.template_url = Urls.Templates.modal;
		this.adv_source = adv_source;
		this.cart_product = cart_product;
		this.modal_selector = '.app-product-cart-modal';
		this.modal = null;
		this.related = false;
		this.recommended = null;
		this.upsale_promos = null;
		this.getRelatedProduct();
	}

	get_context () {
		return {
			related: this.related,
			settings: window.SiteSettings || {},
			cart_url: Urls.Api.cart,
			cart_product: this.cart_product,
			upsale_promos: this.upsale_promos,
			recommended: this.recommended
		};
	}

	after_render () {
		this.initSelectors();
		this.once_rendered();
		this.renderRelatedElements();
	}

	once_rendered () {}

	show_modal (cart_product) {
		this.cart_product = cart_product;
		this.modal = document.querySelector(this.modal_selector);
		this.modal.open();
	}

	hide () {
		this.el.classList.add('d-none');
	}

	getRelatedProduct () {
		fetcher(Urls.Api.product_related)
			.then(data => {
				const upsale_promos = data.UpSalePromos;
				let product_upsale_promos = null;
				if (upsale_promos.length > 0) {
					product_upsale_promos = upsale_promos.filter((promo) => {
						return promo.ShoppingCartProductId === this.cart_product.Id;
					});
				}
				this.upsale_promos = product_upsale_promos;
				this.recommended = data.Recommendation;
				this.render();
			});
	}

	addRecommended (event) {
		const btn_element = event.currentTarget;
		if (!btn_element.classList.contains('in-cart') ) {
			const product_data = {
				ProductId: btn_element.getAttribute('data-id'),
				ParentId: null,
				Qty: 1,
				DefaultOptions: btn_element.getAttribute('data-default-options' ) ? true : false
			};
			if (this.adv_source) {
				product_data.Source = 'ad';
			}
			btn_element.setAttribute('disabled', true);
			btn_element.classList.add('progress');
			fetch(Urls.Api.product, {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				method: 'post',
				body: JSON.stringify(product_data)
			})
			.then(fetch_status)
			.then(fetch_json)
			.then(response => {
				const data = Object.assign(response, { source: 'Product Cart Modal', sku: this.cart_product.Sku });
				const product_added_event = new CustomEvent('[add-to-cart]:product-added', { detail: data });
				btn_element.classList.add('in-cart');
				btn_element.textContent = 'In cart';
				document.dispatchEvent(product_added_event);
			})
			.catch(error => {
				fetch_error(error, true)
					.then(error_json => {
						this.showError(error_json);
					});
			})
			.finally(() => {
				btn_element.removeAttribute('disabled');
				btn_element.classList.remove('progress');
			});
		}
	}

	saveQty (qty) {
		return fetch(Urls.Api.product, {
			method: 'post',
			body: JSON.stringify(Object.assign(this.cart_product, { Qty: qty }))
		})
		.then(fetch_status)
		.catch(error => {
			fetch_error(error, true)
				.then(error_json => {
					this.showError(error_json);
				});
			});
	}

	addPromo (event) {
		const btn_element = event.currentTarget;
		if (!btn_element.classList.contains('in-cart')) {
			const cart_qty = btn_element.getAttribute('data-cart-qty');
			btn_element.setAttribute('disabled', true);
			btn_element.classList.add('progress');
			if (this.cart_product.Qty < cart_qty) {
				this.saveQty(cart_qty)
					.then(() => {
						this.savePromo(btn_element.getAttribute('data-id'))
							.then(() => {
								btn_element.classList.remove('progress');
								btn_element.classList.add('in-cart');
								btn_element.textContent = 'In cart';
							});
					});
			} else {
				this.savePromo(btn_element.getAttribute('data-id'))
					.then(fetch_status)
					.then(fetch_json)
					.then(response => {
						btn_element.classList.remove('progress');
						btn_element.classList.add('in-cart');
						btn_element.textContent = 'In cart';
						const data = Object.assign(response, { source: 'Product Cart Modal Upsale Autopromo' });
						const product_added_event = new CustomEvent('[add-to-cart]:product-added', { detail: data });
						document.dispatchEvent(product_added_event);
					} );
			}
		}
	}

	savePromo (promo_id) {
		const url = Urls.Api.up_sale_promos_apply(promo_id);
		return fetch(url, {
			method: 'post'
			})
			.catch(error => {
				fetch_error(error, true)
					.then(error_json => {
						this.showError(error_json);
					});
			});
	}

	showError (error) {
		let message = 'Something went wrong...';
		if (error) {
			message = error.responseJSON.Message ? error.Message : error.responseJSON.Message;
		}
		if (this.message_element) {
			this.message_element.querySelector('p').textContent = message;
			this.message_element.classList.remove('hide');
		} else {
			window.alert(message);
		}
	}

	hideError () {
		this.message_element.classList.add('hide');
	}

	renderRelatedElements () {
		this.html_render({
			related: true,
			upsale_promos: this.upsale_promos,
			recommended: this.recommended
		}).then(html => {
			const root = document.createElement('div');
			let accessories_element = null;

			root.innerHTML = html;
			accessories_element = root.querySelector('.cart-product-accessories');
			this.related_element.innerHTML = '';
			if (accessories_element) {
				this.related_element.append(accessories_element);
			}

			this.initSelectors();
		});
	}

	hideModal () {
		this.modal.close();
	}

	initSelectors () {
		this.removeListeners();
		this.related_element = document.querySelector('.related');
		this.message_element = document.querySelector('.message');
		this.add_promo_btns = document.querySelectorAll('.cart-product-upsales [name="add-promo"]');
		this.add_recommended_btns = document.querySelectorAll('.cart-product-accessories [name="add-recommended"]');
		this.modal_btn = document.querySelector('.modal-message .btn');
		this.close_modal_btn = document.querySelector('.js-cart-popup-dismiss');
		this.addListeners();
	}

	addListeners () {
		if (this.add_promo_btns) {
			this.add_promo_btns.forEach(element => element.addEventListener('click', this.addPromo.bind(this)));
		}
		if (this.add_recommended_btns) {
			this.add_recommended_btns.forEach(element => element.addEventListener('click', this.addRecommended.bind(this)));
		}
		if (this.modal_btn) {
			this.modal_btn.addEventListener('click', this.hideError);
		}
		if (this.close_modal_btn) {
			this.close_modal_btn.addEventListener('click', this.hideModal.bind(this));
		}
	}

	removeListeners () {
		if (this.add_promo_btns) {
			this.add_promo_btns.forEach(element => element.removeEventListener('click', this.addPromo.bind(this)));
		}
		if (this.add_recommended_btns) {
			this.add_recommended_btns.forEach(element => element.removeEventListener('click', this.addRecommended.bind(this)));
		}
		if (this.modal_btn) {
			this.modal_btn.removeEventListener('click', this.hideError);
		}
		if (this.close_modal_btn) {
			this.close_modal_btn.removeEventListener('click', this.hideModal.bind(this));
		}
	}
}